// import { truncateStringWithEllipsis } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import { getUserDepartment } from "../../utils";
import { Badge } from "../Badge";
interface IUserIconViewProps {
  navigateToProfile: () => void;
  navigateToChangePassword: () => void;
  navigateToCreatePin: () => void;
  navigateToChangePin: () => void;
  onSignOut: () => void;
}

export const UserIconView = (props: IUserIconViewProps) => {
  const { active_tenant_id, user, staff_departments } = useAuth();
  const activeDept = getUserDepartment(active_tenant_id, staff_departments);

  return (
    <div className="flex-container col">
      <div className="user-top">
        <div className="notification-head-text">
          {/* To get the users name */}
          <h5>{user?.last_name + " " + user?.first_name}</h5>
          <p className="user-email">{user?.email}</p>
        </div>
        <div className="notification-sub-text mt-5">
          {staff_departments
            .find((dpt) => dpt.merchant_id === active_tenant_id)
            ?.department_access_policies?.map((policy) => (
              <Badge
                text={policy}
                hideIndicator
                statusColor={
                  policy.toLowerCase() === "owner" ? "teal" : "primary"
                }
                className="text-dark mr-5"
              />
            ))}
        </div>
      </div>

      <div onClick={props.navigateToProfile} className="user-buttons">
        Settings
      </div>

      <div onClick={props.navigateToChangePassword} className="user-buttons">
        Change Password
      </div>

      <div
        onClick={
          activeDept?.has_pin
            ? props.navigateToChangePin
            : props.navigateToCreatePin
        }
        className="user-buttons"
      >
        {activeDept?.has_pin ? "Change" : "Create"} Transfer PIN
      </div>

      <div onClick={props.onSignOut} className="user-buttons red">
        Sign out
      </div>
    </div>
  );
};
